module.exports = __webpack_public_path__ + "img/Flag_of_Georgia.d22e802c.svg";